/**
 * Resolve a lesson’s practice sequence: prefer stored `sequence`, else migrate cues.
 */

import { cuesToSequence } from './cuesToSequence';
import { cuesForPlan } from './planTypes';
import { normalizeSequence } from './sequenceModel';

export function getLessonSequence(lesson, planType) {
  if (!lesson) return [];
  const style = lesson.style;
  if (Array.isArray(lesson.sequence) && lesson.sequence.length) {
    return normalizeSequence(lesson.sequence, { style });
  }
  const cues = cuesForPlan(lesson, planType);
  return cuesToSequence(cues, {
    style,
    durationMins: lesson.durationMins,
  });
}
